import * as activity from './activity';
import * as automation from './automation';
import * as billing from './billing';
import * as bundle from './bundle';
import * as business from './business';
import * as card from './card';
import * as channel from './channel';
import * as dashboard from './dashboard';
import * as entity from './entity';
import * as fileOperation from './fileOperation';
import * as link from './link';
import * as report from './report';
import * as search from './search';
import * as tool from './tool';
import * as user from './user';
import * as viewTemplate from './viewTemplate';
import * as workflow from './workflow';

export const Queries = {
  activity,
  billing,
  bundle,
  business,
  card,
  channel,
  entity,
  link,
  search,
  tool,
  user,
  viewTemplate,
  report,
  workflow,
  dashboard,
  automation,
  fileOperation,
};
